import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StatusService } from '../status.service';
import { AuthService } from 'src/app/services/auth.service';
import { Observable, finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { Status, UpdateStatus } from '../status.interface';

@Component({
    selector: 'app-edit-status',
    templateUrl: './edit-status.component.html',
    styleUrls: ['./edit-status.component.scss'],
})
export class EditStatusComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    ranks$!: Observable<any[]>;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
        color: new FormControl(this.data.color, [Validators.required]),
        rank: new FormControl(this.data.rank, [Validators.required]),
        observations: new FormControl(this.data.observations),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditStatusComponent>,
        private statusService: StatusService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() {
        this.loadRanks();
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.statusService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, slug, color, rank, observations } = this.form
            .value as Status;

        const updatedStatusData: UpdateStatus = {
            id_cerere_status: this.data.id_cerere_status,
            name,
            slug,
            color,
            rank,
            observations
        };

        this.statusService
            .updateStatus(updatedStatusData)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    loadRanks() {
        this.isLoading = true;
        this.ranks$ = this.statusService
            .getRanksList()
            .pipe(finalize(() => (this.isLoading = false)));
    }
}
